import { QueueType, UserTypes } from '../dot-net-api-types/data-contracts';

/**
 * Stub for Queue Endpoints
 */
export interface IQueueEndpoints {
  getQueue: () => string;
  createQueue: () => string;
  updateQueue: (queueId: string) => string;
  deleteQueue: (queueId: string) => string;
  getCallerQueueContent: () => string;
  getQueueDropdowns: () => string;
  // ToDo: 8/11/2025 - Currently not setup due to all the confusion about what is a "queue"
  getQueueContent: () => string;
  getQueueUsersById: (queueId: string) => string;
  getQueueUsersByIdSimple: (queueId: string) => string;
  isUserAssignedToQueueUsingId: (queueId: string, userId: string) => string;
  isUserAssignedToQueueUsingType: (queueType: QueueType, userId: string) => string;
  assignFillingFromQueueModule: (queueId: string) => string;
  assignFillingFromCPM: (queueId: string) => string;
  assignCaseToQueue: (queueId: string) => string;
  assignDocumentToQueue: (queueId: string) => string;
  unassignFilingFromQueue: (filingId: string) => string;
  unassignCaseFromQueue: (caseId: string) => string;
  unassignDocumentFromQueue: (documentId: string) => string;
  // Todo: 8/11/2025 - Item Ids are queue Item guids, not filing nor case ids.
  assignUserToQueueItems: () => string;
  removeItemsFromQueue: () => string;
  /*********************************************************************************************************************
   * Tags
   * ******************************************************************************************************************/
  getItemsByTagId: (tagId: string) => string;
  deleteTag: (tagId: string) => string;
  addTagToQueueItem: (tagId: string, itemId: string) => string;
  removeTagFromQueueItem: (itemId: string, tagId: string) => string;
  getQueueTags: (queueId: string) => string;
  putTagContentToQueueItem: (content: string, itemId: string) => string;
  /*********************************************************************************************************************
   * Users
   * ******************************************************************************************************************/
  getUserAssignedQueues: (userId: string) => string;
  assignUserToQueues: (userId: string) => string;
  updateUserQueuePermissions: (userId: string) => string;
  unassignUserFromQueues: (userId: string) => string;
  getUserAllowableQueues: (userType: UserTypes) => string;
  batchAssignUsersToQueues: () => string;
  batchUnassignUsersToQueues: () => string;
  /*********************************************************************************************************************
   * Bookmarks
   ********************************************************************************************************************/
  bookmark: () => string;
}

/**
 * Queue endpoints
 * @param versionedUrl
 */
export const queueEndpoints = (versionedUrl: string): IQueueEndpoints => {
  const baseUrl = `${versionedUrl}api/Queue`;

  return {
    getQueue: () => `${baseUrl}`,
    createQueue: () => `${baseUrl}/Create`,
    updateQueue: (queueId: string) => `${baseUrl}/${queueId}`,
    deleteQueue: (queueId: string) => `${baseUrl}/${queueId}`,
    getCallerQueueContent: () => `${baseUrl}`,
    getQueueDropdowns: () => `${baseUrl}/Dropdowns`,
    getQueueContent: () => `${baseUrl}`,
    getQueueUsersById: (queueId: string) => `${baseUrl}/${queueId}/Users`,
    getQueueUsersByIdSimple: (queueId: string) => `${baseUrl}/${queueId}/Users/Simple`,
    isUserAssignedToQueueUsingId: (queueId: string, userId: string) => `${baseUrl}/${queueId}/Users/${userId}`,
    isUserAssignedToQueueUsingType: (queueType: QueueType, userId: string) => `${baseUrl}/${queueType}/Users/${userId}`,
    assignFillingFromQueueModule: (queueId: string) => `${baseUrl}/Assign/${queueId}`,
    assignFillingFromCPM: (queueId: string) => `${baseUrl}/Assign/${queueId}/CPM`,
    assignCaseToQueue: (queueId: string) => `${baseUrl}/Assign/${queueId}/Case`,
    assignDocumentToQueue: (queueId: string) => `${baseUrl}/Assign/${queueId}/Document`,
    unassignFilingFromQueue: (filingId: string) => `${baseUrl}/Unassign/Filing/${filingId}`,
    unassignCaseFromQueue: (caseId: string) => `${baseUrl}/Unassign/Case/${caseId}`,
    unassignDocumentFromQueue: (documentId: string) => `${baseUrl}/Unassign/Document/${documentId}`,
    assignUserToQueueItems: () => `${baseUrl}/Assign/User`,
    removeItemsFromQueue: () => `${baseUrl}/Remove`,
    // Tags
    getItemsByTagId: (tagId: string) => `${baseUrl}/Tag/${tagId}`,
    deleteTag: (tagId: string) => `${baseUrl}/Tag/${tagId}`,
    getQueueTags: (queueId: string) => `${baseUrl}/Tag/${queueId}/List`,
    addTagToQueueItem: (tagId: string, itemId: string) => `${baseUrl}/Tag/${tagId}/${itemId}`,
    removeTagFromQueueItem: (itemId: string, tagId: string) => `${baseUrl}/Tag/${tagId}/${itemId}`,
    putTagContentToQueueItem: (content: string, itemId: string) => `${baseUrl}/Tag/${content}/${itemId}`,
    // Users
    getUserAssignedQueues: (userId: string) => `${baseUrl}/Users/${userId}`,
    assignUserToQueues: (userId: string) => `${baseUrl}/Users/${userId}`,
    updateUserQueuePermissions: (userId: string) => `${baseUrl}/Users/${userId}`,
    unassignUserFromQueues: (userId: string) => `${baseUrl}/Users/${userId}`,
    getUserAllowableQueues: (userType: UserTypes) => `${baseUrl}/Users/${userType}`,
    batchAssignUsersToQueues: () => `${baseUrl}/Users/Batch`,
    batchUnassignUsersToQueues: () => `${baseUrl}/Users/Batch`,
    // Bookmarks
    bookmark: () => `${baseUrl}/Bookmark`
  };
}
